import React, { useState } from "react";
import "./ContactUs.css";
import axios from "axios";
import API_BASE_URL from "../../api/Config";
import toast from "react-hot-toast";
import SEO from "../SEO";

const ContactUs = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    subject: "",
    message: "",
  });
  const [formStatus, setFormStatus] = useState(null);
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validateForm = () => {
    if (!formData.name.trim()) {
      toast.error("Please enter your name.");
      return false;
    }
    if (!formData.email.trim()) {
      toast.error("Please enter your email.");
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(formData.email)) {
      toast.error("Please enter a valid email address.");
      return false;
    }
    if (!formData.subject.trim()) {
      toast.error("Please enter your subject.");
      return false;
    }
    if (!formData.message.trim()) {
      toast.error("Please enter your message.");
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormStatus(null);

    if (!validateForm()) {
      return;
    }

    try {
      const response = await axios.post(`${API_BASE_URL}/contact-us/submit`, formData);

      if (response.status === 200 || response.status === 201) {
        toast.success("Thank you for your message! We will get back to you soon.");
        setFormStatus("Thank you for your message! We will get back to you soon.");
        setFormData({ name: "", email: "", subject: "", message: "" });
      } else {
        toast.error("Failed to send message. Please try again later.");
        setFormStatus("Failed to send message. Please try again later.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      toast.error("Failed to send message. Please try again later.");
      setFormStatus("Failed to send message. Please try again later.");
    }
  };

  const structuredData = {
    "@context": "https://schema.org",
    "@type": "ContactPage",
    "name": "Contact Techie Interiors",
    "description": "Get in touch with Techie Interiors for interior design consultations and quotes in Nairobi Kenya",
    "url": "https://techieinteriors.co.ke/contact-us",
    "mainEntity": {
      "@type": "LocalBusiness",
      "name": "Techie Interiors",
      "telephone": "+254748600208",
      "email": "info@techieinteriors.co.ke",
      "address": {
        "@type": "PostalAddress",
        "addressLocality": "Nairobi",
        "addressCountry": "KE"
      },
      "openingHours": "Mon-Sat 08:00-18:00"
    }
  };

  return (
    <div className="contact-us-page">
      {/* SEO Component */}
      <SEO
        title="Contact Techie Interiors | Get Free Interior Design Quote Kenya"
        description="Contact Techie Interiors for free interior design consultations in Nairobi Kenya. Get quotes for gypsum ceilings, wardrobes, kitchen cabinets, TV wall units, and more. Call +254 748600208."
        keywords="contact Techie Interiors, interior design consultation Nairobi, interior design quote Kenya, contact interior designers Nairobi"
        image="/techLogo.jpeg"
        url="https://techieinteriors.co.ke/contact-us"
        structuredData={structuredData}
      />
      <div className="contact-us-container">
        <h1 className="contact-us-title">Contact Us</h1>
        <p className="contact-us-description">
          Got a question or ready to transform your space? Get in touch with Techie Interiors today and let’s bring your ideas to life. We’ll get back to you shortly!
        </p>
        <div className="contact-us-content">
          {/* Contact Form Column */}
          <div className="contact-form-container">
            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <label htmlFor="name">Name</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Your Name"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">Email</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="Your Email"
                />
              </div>

              <div className="form-group">
                <label htmlFor="subject">Subject</label>
                <input
                  type="tel"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Enter Subject"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Message</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  placeholder="Your Message"
                />
              </div>

              <button type="submit" className="submit-button">
                Send 
              </button>
            </form>

            {formStatus && (
              <div className="form-status" role="status">
                {formStatus}
              </div>
            )}
          </div>

          {/* Contact Details Column */}
          <div className="contact-details-container">
            <h2 className="contact-details-title">Our Contact Details</h2>
            <ul className="contact-details-list">
              <li>
                <strong>Phone:</strong> +254748600208
              </li>
              <li>
                <strong>Whatsapp:</strong> +254748600208
              </li>
              <li>
                <strong>Email:</strong> info@techieinteriors.co.ke
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
